import { render, staticRenderFns } from "./GrowthByBiz.vue?vue&type=template&id=50fe8eee&lang=pug"
import script from "./GrowthByBiz.vue?vue&type=script&lang=js"
export * from "./GrowthByBiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports